import { RoutesService, SettingTabsService } from '@abp/ng.core';
import { eSettingManagementRouteNames } from '@abp/ng.setting-management';
import { APP_INITIALIZER } from '@angular/core';
import { debounceTime, map } from 'rxjs/operators';
import { SettingsComponent } from '../components/settings/settings.component';
import { eMetronicThemeSettingTabNames } from '../enums/setting-tab-names';

export const METRONIC_THEME_SETTING_TAB_PROVIDERS = [
	{
		provide: APP_INITIALIZER,
		useFactory: configureSettingTabs,
		deps: [SettingTabsService],
		multi: true,
	},
	{
		provide: APP_INITIALIZER,
		useFactory: showRoutes,
		deps: [RoutesService, SettingTabsService],
		multi: true,
	},
];

export function configureSettingTabs(settingtabs: SettingTabsService) {

	return () => {
		settingtabs.add([
			{
				name: eMetronicThemeSettingTabNames.MetronicThemeManagement,
				order: 2,
				component: SettingsComponent,
				// requiredPolicy: 'MetronicThemeManagement.Settings',
			},
		]);
		
	};
}

export function showRoutes(routesService: RoutesService, settingTabsService: SettingTabsService) {
	return () => {
		settingTabsService.tree$
			.pipe(
				debounceTime(100)
			)
			.subscribe(() =>
				routesService.patch(eSettingManagementRouteNames.Settings, { invisible:false }),
			);
	};
}
